import { MarketplaceMapPointAreaDto } from "../../../../../../networking/data/responses/marketplace/mapPoints/MarketplaceMapPointAreaDto";

export class MapArea {
    public readonly area: number;
    public readonly buildingsAmount: number;

    public constructor(mapAreaDto: MarketplaceMapPointAreaDto) {
        if (mapAreaDto == undefined) {
            throw new Error("Failed to create MapArea without mapAreaDto.");
        }
        if (mapAreaDto.area == undefined || isNaN(mapAreaDto.area)) {
            throw new Error("Failed to create MapArea without area data.");
        }
        if (mapAreaDto.buildingsAmount == undefined || isNaN(mapAreaDto.buildingsAmount)) {
            throw new Error("Failed to create MapArea without buildingsAmount data.");
        }
        this.area = mapAreaDto.area;
        this.buildingsAmount = mapAreaDto.buildingsAmount;
    }

}
